import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { InputComponent } from './input.component';

@Component({
  selector: 'app-text-input',
  template: `
    <textarea
      class="inp"
      id="app-scroll"
      placeholder="{{ placeholder }}"
      (paste)="pasted.emit($event)"
      (keydown)="onTextareaKeydown($event)"
      [attr.tabindex]="tabindex"
      [attr.autocomplete]="autocomplete"
      [attr.name]="name"
      [attr.enterkeyhint]="enterkeyhint"
      [attr.inputmode]="inputmode"
      [attr.maxlength]="maxLength"
      #input></textarea>
    @if (maxLength && !hideCounter) {
      <div class="counter">{{ (changed$ | async)?.length || 0 }}/{{ maxLength }}</div>
    }
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true,
    },
  ],
  styleUrls: ['./styles/input.scss', './styles/text-input.scss', './styles/input-validation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextInputComponent extends InputComponent implements ControlValueAccessor {
  @Output()
  pasted = new EventEmitter();

  @Input()
  tabindex = 0;

  @Input()
  hideCounter: boolean = false;

  onTextareaKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.enterkeyhint === 'done') {
      event.preventDefault(); // prevent newline
      (event.target as HTMLTextAreaElement).blur(); // closes keyboard
    }
  }
}
